import { Injectable } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PRODUCT_GROUPS } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';
import { DateService } from 'src/app/shared/services/date.service';
import { FormError } from 'src/app/angular-elements/shared/components/interfaces/form-error.interface';
import { ApplicationQualificationStateStructure } from '../../../../interfaces/applicationQualificationStateStructure.interface';
import { MedigapRequiredDocumentUploadStateStructure, MEDIGAP_FORM_DOCUMENT_UPLOAD_REDUCER_NAME } from '../../../../../form-wrappers/form-components/required-docs-upload/medigap-form.doc-upload.reducer';

@Injectable({
    providedIn: 'root'
})
export class EnrollmentSubmissionMedigapService {

    productGroup = PRODUCT_GROUPS.MEDIGAP;
    productType = 'MG';

    constructor(
        private reducerUtilityService: ReducerUtilityService,
        private dateUtility: DateService
    ) { }


    getEligibilityCheckStateInfo(payloadState) {
        const applicationQualification: ApplicationQualificationStateStructure = this.reducerUtilityService.getPayloadState('applicationQualification');

        payloadState.medigapEligibilityCheck.medigapQualification = applicationQualification.payload.qualified;
        payloadState.medigapEligibilityCheck.initialEntryDate = this.dateUtility.getDateAsFormattedString(new Date().toString(), 'MM/DD/YYYY');
        payloadState.medigapEligibilityCheck.medigapApplication = applicationQualification.payload.application || "GI";

        if (payloadState.medigapEligibilityCheck.currentContractCancellationDate) {
            this.dateUtility.getDateAsFormattedString(payloadState.medigapEligibilityCheck.currentContractCancellationDate, 'MM/DD/YYYY');
        }
    }

    setDocumentValues(payloadState: any, activeProductGroup: PRODUCT_GROUPS) {
        const medigapFormDocUpload: MedigapRequiredDocumentUploadStateStructure = this.reducerUtilityService.getState(MEDIGAP_FORM_DOCUMENT_UPLOAD_REDUCER_NAME);
        payloadState.enrollment.uploadedDocumentIds = medigapFormDocUpload.documents.map(d => d.displayableFileObj.documentRecord);

        if (activeProductGroup === PRODUCT_GROUPS.MEDICARE_SUPPLEMENT) {
            if (payloadState.medigapEligibilityCheck.currentMedicarePolicyAndBirthday === 'YES') {
                payloadState.enrollment.uploadRequiredDocsNow = 'yes';
            }
            else {
                payloadState.enrollment.uploadedDocumentIds = [];
                delete payloadState.enrollment.uploadRequiredDocsNow;
            }
        }
    }

    getMedicationsStateInfo(payloadState) {
        payloadState.medications = payloadState.medigapEnrollmentMedications.medicationForm.medications;
        delete payloadState.medigapEnrollmentMedications;
    }

    validateMandatoryFields(payload: any, activeProductGroup: PRODUCT_GROUPS): FormError {
        const formErr: FormError = {
            valid: true,
            fieldName: ''
        };
        if (activeProductGroup === PRODUCT_GROUPS.MEDIGAP || activeProductGroup === PRODUCT_GROUPS.MEDICARE_SUPPLEMENT) {
            if (payload.enrollment && payload.enrollment.productData
            ) {
                if (!payload.enrollment.productData.superProductId) {
                    formErr.valid = false;
                    formErr.fieldName = 'Super product ID';
                }
            } else {
                formErr.valid = false;
            }
        }
        return formErr;
    }
}

